<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 id="toc_marker-1" title="Copyright"></h1>
<p class="small">InterVarsity Press<br/>
    P.O. Box 1400,<br/>
    Downers Grove, IL 60515-1426<br/>
    World Wide Web: <a href="http://www.ivpress.com" target="_blank"><span class="hyperlinks">www.ivpress.com</span></a><br/>
    Email: <a href="mailto:email%40ivpress.com?subject="><span class="hyperlinks">email@ivpress.com</span></a></p>
<p class="small">©2013 by Kelly M. Kapic and Wesley Vander Lugt</p>
<p class="small">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="small">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept., InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <a href="http://www.intervarsity.org" target="_blank"><span class="hyperlinks">www.intervarsity.org</span></a>.</p>
<p class="small">Cover design: Cindy Kiple<br/>
    Image: Reformed tradition: Roberta Polfus</p>
<p class="small">ISBN 978-0-8308-2708-4 (print)<br/>
    ISBN 978-0-8308-8443-8 (digital)</p>
<p class="small"></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Copyright.vue?49e063c6